import React from 'react'
import classnames from 'classnames'

import styles from '../header.module.less'

const Left = ({ icon, className, children, ...rest }) => {
  const style = classnames(styles.left, className, {
    [styles.hasIcon]: icon,
  })
  return (
    <div className={style} {...rest}>
      {children}
    </div>
  )
}

Left.defaultProps = {
  className: '',
  icon: false,
}

export default Left
